import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import FormikTransferListSearchable, {
   FormikTransferListSearchableProps,
} from 'components/inputs/FormikTransferListSearchable';

export const VALUE_NAME = 'value';

const defaultValidationSchema = yup.object({
   [VALUE_NAME]: yup.array().of(yup.string()),
});

export type TransferListDialogFormType = yup.InferType<typeof defaultValidationSchema>;

export interface TransferListDialogDialogProps {
   data: {
      title: string;
      optionsLabel: FormikTransferListSearchableProps['optionsLabel'];
      valuesLabel: FormikTransferListSearchableProps['valuesLabel'];
      options: FormikTransferListSearchableProps['options'];
      open?: boolean;
      value?: string[];

      name?: string;
      validationSchema?: yup.ObjectSchema;
   };
   onClose: (
      nameObj?: TransferListDialogFormType,
      callbacks?: FormOnSubmitHelpers<TransferListDialogFormType>
   ) => void;
}
export const TransferListDialog = memo(
   ({
      data: {
         title,
         value,
         open = true,
         optionsLabel,
         valuesLabel,
         options,

         validationSchema = defaultValidationSchema,
         name = VALUE_NAME,
      },
      onClose: onSubmit,
   }: TransferListDialogDialogProps) => {
      const onClose = React.useCallback(() => onSubmit(), [onSubmit]);

      // console.debug('options', options);
      // console.debug('value', value);
      return (
         <Dialog open={open} maxWidth="sm" header={title} close={onClose}>
            <Formik
               initialValues={validationSchema.cast({value})}
               enableReinitialize
               // initialTouched={Boolean(value) ? [VALUE_NAME] : undefined}
               validationSchema={validationSchema}
               onSubmit={onSubmit}
            >
               <TransferListDialogForm
                  name={name}
                  cancel={onClose}
                  optionsLabel={optionsLabel}
                  valuesLabel={valuesLabel}
                  options={options}
               />
            </Formik>
         </Dialog>
      );
   }
);

const TransferListDialogForm = ({
   name,
   cancel,
   optionsLabel,
   valuesLabel,
   options,
}: {
   name: string;
   cancel: () => void;
   optionsLabel: FormikTransferListSearchableProps['optionsLabel'];
   valuesLabel: FormikTransferListSearchableProps['valuesLabel'];
   options: FormikTransferListSearchableProps['options'];
}) => {
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <FormikTransferListSearchable
                  name={name}
                  optionsLabel={optionsLabel}
                  valuesLabel={valuesLabel}
                  options={options}
                  // freeze={['ALL USERS']}
                  // inverse
                  // disabled
               />
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={cancel} />
            </Grid>
         </Grid>
      </>
   );
};
